import { daysPerYear } from "@/ts/date-time/date-time"
import {
  type SessionCookie,
  type SessionData,
  sessionCookieName,
} from "../session-data.types"

export function mapToSessionCookie(sessionData: SessionData): SessionCookie {
  return {
    cookieName: sessionCookieName,
    options: {
      expires: daysPerYear,
      path: "/",
      sameSite: "lax",
      secure: true,
    },
    rawSessionCookieData: JSON.stringify(sessionData),
  }
}
